<template>
    <div class="HowTobuy">
        <navbar :transparent="isTransparent"></navbar>
        <div class="HowTobuy_wrap">
            <h1 class="howtoway-title">{{$t('footer_howtoway')}}</h1>
            <div class="HowTobuy_step">
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step1')}}
                    </p>
                    <p class="font_mid">
                        {{$t('howtobuy_step1_content')}}
                    </p>
                </div>
                <img src="../assets/howtobuy/howtobuy1.jpg" style="max-width: 1000px;float: left;width: 100%;" v-if="this.Howlang == 'cn' ">
                <img src="../assets/howtobuy/step1_sc@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'sc' ">
                <img src="../assets/howtobuy/step1_en@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'en' ">
            </div>
            <div style="clear: both"></div>
            <div class="HowTobuy_step">
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step2')}}
                    </p>
                </div>
                <img src="../assets/howtobuy/step2_tc@2x.jpg" style="float: left;width: 100%;" v-if="this.Howlang == 'sc' ">
                <img src="../assets/howtobuy/step2_sc@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'cn' ">
                <img src="../assets/howtobuy/step2_en@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'en' ">
            </div>
            <div style="clear: both"></div>
            <div class="HowTobuy_step">
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step3')}}
                    </p>
                    <p class="font_mid">
                        {{$t('howtobuy_step3_content1')}}
                    </p>
                    <p class="font_mid">
                        {{$t('howtobuy_step3_content2')}}
                    </p>
                    <p class="font_mid">
                        {{$t('howtobuy_step3_content3')}}
                    </p>
                </div>
                <img src="../assets/howtobuy/step3_tc@2x.jpg" style="float: left;width: 100%;" v-if="this.Howlang == 'sc' ">
                <img src="../assets/howtobuy/step3_sc@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'cn' ">
                <img src="../assets/howtobuy/step3_en@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'en' ">
            </div>
            <div style="clear: both"></div>
            <div class="HowTobuy_step">
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step4')}}
                    </p>
                    <p class="font_mid">
                        {{$t('howtobuy_step4_content1')}}
                    </p>
                </div>
                <img src="../assets/howtobuy/step4_1tc@2x.jpg" style="float: left;width: 100%;" v-if="this.Howlang == 'sc' ">
                <img src="../assets/howtobuy/step4_1sc@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'cn' ">
                <img src="../assets/howtobuy/step4_1en@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'en' ">
                <div style="clear: both"></div>
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step4_content2')}}
                    </p>
                </div>
                <img src="../assets/howtobuy/step4_2tc@2x.jpg" style="float: left;width: 100%;" v-if="this.Howlang == 'sc' ">
                <img src="../assets/howtobuy/step4_2sc@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'cn' ">
                <img src="../assets/howtobuy/step4_2en@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'en' ">
                <div style="clear: both"></div>
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step4_content3')}}
                    </p>
                </div>
                <img src="../assets/howtobuy/step4_3tc@2x.jpg" style="float: left;width: 100%;" v-if="this.Howlang == 'sc' ">
                <img src="../assets/howtobuy/step4_3sc@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'cn' ">
                <img src="../assets/howtobuy/step4_3en@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'en' ">
            </div>
            <div style="clear: both"></div>
            <div class="HowTobuy_step">
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step5')}}
                    </p>
                    <p class="font_mid">
                        {{$t('howtobuy_step5_content')}}
                    </p>
                </div>
                <img src="../assets/howtobuy/step5_tc@2x.jpg" style="float: left;width: 100%;" v-if="this.Howlang == 'sc' ">
                <img src="../assets/howtobuy/step5_sc@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'cn' ">
                <img src="../assets/howtobuy/step5_en@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'en' ">
                <div style="clear: both"></div>
            </div>
            <div class="HowTobuy_step">
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step6')}}
                    </p>
                    <p class="font_mid">
                        {{$t('howtobuy_step6_content')}}
                    </p>
                </div>
                <img src="../assets/howtobuy/step6_tc@2x.jpg" style="float: left;width: 100%;" v-if="this.Howlang == 'sc' ">
                <img src="../assets/howtobuy/step6_sc@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'cn' ">
                <img src="../assets/howtobuy/step6_en@2x.jpg" style="float: left;width: 100%;" v-else-if="this.Howlang == 'en' ">
                <div style="clear: both"></div>
            </div>
            <div style="clear: both"></div>
            <div class="HowTobuy_step">
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step7')}}
                    </p>
                    <p class="font_mid">
                        {{$t('howtobuy_step7_content')}}
                    </p>
                </div>
                <div class="download">
                    <div class="mogos">
                        <img src="../assets/howtobuy/qr1@2x.png">
                        <p>{{$t('mini_program')}}</p>
                    </div>
                    <div class="mogos">
                        <img src="../assets/howtobuy/qr2@2x.png">
                        <p>{{$t('user_center_iapp_qrcode')}}</p>
                    </div>
                    <div class="iapp">
                        <img src="../assets/howtobuy/ios@2x.png">
                        <img src="../assets/howtobuy/android@2x.png">
                    </div>
                </div>
                <div style="clear: both"></div>
                <div class="HowTobuy_step_detail">
                    <p class="font_mid">
                        {{$t('howtobuy_step7_content1')}}：<a href="web.ifree.ly" style="color: #0084ff">web.ifree.ly</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="how_footer">
            <div class="how_footer_list" v-for="(list,index) in suport" :key="index">
                <span>
                    <img :src="list.img" width="40">
                </span>
                <span class="font_mid" style="font-size: 14px;margin-left: 25px;">
                        {{list.content}}
                </span>
            </div>
        </div>

    </div>
</template>

<script>
    import navbar from './Common/Navbar.vue'

    export default {
        data() {
            return {
                isTransparent: false,
                Howlang: 'cn',
                suport: [
                    {
                        img: require('../assets/howtobuy/security@2x.png'),
                        content: this.$t('how_footer1')
                    },
                    {
                        img: require('../assets/howtobuy/24hour@2x.png'),
                        content: this.$t('how_footer2')
                    },
                    {
                        img: require('../assets/howtobuy/48hour@2x.png'),
                        content: this.$t('how_footer3')
                    },
                    {
                        img: require('../assets/howtobuy/14days@2x.png'),
                        content: this.$t('how_footer4')
                    }
                ]
            }
        },
        components: {
            navbar
        },
        created () {
            this.lang = this.$i18n.locale
            if (this.lang === 'en-US') {
                this.Howlang = 'en'
            } else if (this.lang === 'zh-HK') {
                this.Howlang = 'sc'
            } else if (this.lang === 'zh-CN') {
                this.Howlang = 'cn'
            }
        }
    }
</script>

<style lang="scss">
    @import "../scss/_howtobuy.scss";
</style>



// WEBPACK FOOTER //
// HowTobuy.vue?2024451c